import React, { useEffect, useState } from 'react'
import 'firebase/firebase-firestore'
import { Button } from '@material-ui/core'
import { withRouter } from 'react-router-dom'
import firebase from '../firebase'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';
import BeenhereOutlinedIcon from '@material-ui/icons/BeenhereOutlined';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import PolicyOutlinedIcon from '@material-ui/icons/PolicyOutlined';
import Avatar from '@material-ui/core/Avatar';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

function Menu(props) {
	const baseURL = process.env.PUBLIC_URL;
	const currentUser = firebase.getCurrentUsername();
	const [dialogSession, setDialogSession] = useState(false);
	const [userData, setUserData] = useState('');
	const [userPic, setUserpic] = useState();

	/* Use Effect -------------------------------------------- */	

	useEffect (()=> {
		if(!currentUser) {
			return props.history.replace(baseURL+'/login')
		} else{
			if(JSON.parse(localStorage.getItem('data')) !== null && JSON.parse(localStorage.getItem('data')) !== ''){
				setUserData(JSON.parse(localStorage.getItem('data')));
				setUserpic(localStorage.getItem('pic'));
			} else {
				const data = firebase.db.collection("students").where("uuid", "==", currentUser[0].uid).get().then((querySnapshot) => {
					if(!querySnapshot.empty) {
						setUserData(querySnapshot.docs[0].data());
						setUserpic(querySnapshot.docs[0].data().pic);
					  } else {
						setUserpic({error:'error'});
					  }
				}); 
			}
		}
	},[]);


	/* Dialog session -------------------------------------------- */	
	const dialogOpenSession = () => {
		setDialogSession(true);
	  };
	
	  const dialogCloseSession = () => {
		setDialogSession(false);
	  };

	  /* Logout  -------------------------------------------- */	
	async function logout() {
		await firebase.logout()
		localStorage.clear();
		props.history.push(baseURL+'/')
	}

	/* location -------------------------------------------- */
	const goToLocation = ()=>{
		props.history.replace(baseURL+'/location')
	 }

	/* Policy -------------------------------------------- */
	const goToPolicy = ()=>{
		props.history.replace(baseURL+'/policy')
	}

	/* Profile -------------------------------------------- */
	const goToProfile = ()=>{
		props.history.replace(baseURL+'/profile')
	}
	if (userData != ''){
		if(JSON.parse(localStorage.getItem('data')) == null || JSON.parse(localStorage.getItem('data')) == ''){
			localStorage.setItem('data', JSON.stringify(userData));
			localStorage.setItem('pic', userData.pic);
		}
		return (
			<div className="menuSlider">
				<div className="menuHeader">
					<div className="menuHeaderContainer">
						<Avatar className="avatarMenu" src={userPic} />
						<div>
							<h4>{userData.name} {userData.lastname}</h4>
							<h5><i>"{userData.nick}"</i></h5>
						</div>
					</div>
				</div>
				<List component="nav" aria-label="main mailbox folders">

					<ListItem button onClick={goToProfile}>
						<ListItemIcon>
							<PersonOutlineOutlinedIcon />
						</ListItemIcon>
						<ListItemText primary="Perfil" />
					</ListItem>

					<ListItem button onClick={goToLocation}>
						<ListItemIcon>
							<LocationOnOutlinedIcon />
						</ListItemIcon>
						<ListItemText primary="Contacto" />
					</ListItem>

					<ListItem button onClick={goToPolicy}>
						<ListItemIcon>
							<PolicyOutlinedIcon />
						</ListItemIcon>
						<ListItemText primary="Políticas de privacidad" />
					</ListItem>
						
					<ListItem button onClick={dialogOpenSession}>
						<ListItemIcon>
							<ExitToAppIcon />
						</ListItemIcon>
						<ListItemText primary="Cerrar Sesión" />
					</ListItem>
				</List>
				<div class="version">version 0.1.6</div>

				<Dialog
					open={dialogSession}
					onClose={dialogCloseSession}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
				>
					<DialogContent>
						<DialogContentText id="alert-dialog-description">
							¿Deseas cerrar sesión?
						</DialogContentText>
					</DialogContent>
					<DialogActions>
					<Button onClick={dialogCloseSession} color="primary">
						NO
					</Button>
					<Button onClick={logout} color="primary" autoFocus>
						SI
					</Button>
					</DialogActions>
				</Dialog>
			</div>
		)
	} else {
		return(
			<div>
				<div className="menuHeader">
					<div>
						<Avatar className="avatarMenu">EE</Avatar>
					</div>
				</div>
				<List component="nav" aria-label="main mailbox folders">

					<ListItem button onClick={goToProfile}>
						<ListItemIcon>
							<PersonOutlineOutlinedIcon />
						</ListItemIcon>
						<ListItemText primary="Perfil" />
					</ListItem>

					<ListItem button onClick={goToLocation}>
						<ListItemIcon>
							<LocationOnOutlinedIcon />
						</ListItemIcon>
						<ListItemText primary="Contacto" />
					</ListItem>

					<ListItem button onClick={goToPolicy}>
						<ListItemIcon>
							<PolicyOutlinedIcon />
						</ListItemIcon>
						<ListItemText primary="Políticas de privacidad" />
					</ListItem>
						
					<ListItem button onClick={dialogOpenSession}>
						<ListItemIcon>
							<ExitToAppIcon />
						</ListItemIcon>
						<ListItemText primary="Cerrar Sesión" />
					</ListItem>
				</List>
				<div class="version">version 0.1.5</div>

				<Dialog
					open={dialogSession}
					onClose={dialogCloseSession}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
				>
					<DialogContent>
						<DialogContentText id="alert-dialog-description">
							¿Deseas cerrar sesión?
						</DialogContentText>
					</DialogContent>
					<DialogActions>
					<Button onClick={dialogCloseSession} color="primary">
						NO
					</Button>
					<Button onClick={logout} color="primary" autoFocus>
						SI
					</Button>
					</DialogActions>
				</Dialog>
			</div>	
		)
	}
}

export default withRouter(Menu)